import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import timer from './timer';
import app from './app';
import project from './project';
import report from './report';
import user from './user';

const rootReducer = combineReducers({timer, app, project, report, user, routing: routerReducer });

export default rootReducer;